export const Fire = ({ fill }: { fill: string }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 31.72"
    fill={fill}
  >
    <path
      d="M24.74,15.66C23.86,8,19.48,1.58,14.67,0a11.12,11.12,0,0,1,.58,1.88A9,9,0,0,1,13.42,10a4.39,4.39,0,0,1-3.36,1.7,2,2,0,0,1-.81-.2c-2.52-.32-4.87-2.57-5.94-5.75A20.64,20.64,0,0,0,0,15.66c-1.06,8.87,4.47,16.06,12.37,16.06S25.8,24.53,24.74,15.66ZM15.09,26.2c-9,3.15-7.71-4.36-7.66-4.36S8,19,12.91,18.08c2.33-.41,4.09-2.68,4.93-4.6C17.69,13.48,23,22.74,15.09,26.2Z"
      transform="translate(0.13)"
    />
  </svg>
);
